import { inject } from "vue";
import { VUE_APPLICATION_INSIGHTS } from "@/services/application-insights/application-insights";
import type { ApplicationInsights } from "@microsoft/applicationinsights-web";

export function useApplicationInsights() {
  return <ApplicationInsights>inject<ApplicationInsights>(VUE_APPLICATION_INSIGHTS);
}
